export enum TableColumnInputEnum {
    none,
    checkbox,
    text,
    textarea,
    linkList,
    custom
}
